import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useContext, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../../../../components/Loading/Loading";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import localeText from "../../../../locale";
// import GetUserInfoService from "../../../../service/GetUserInfoService";
import OrderService from "../../../../service/OrderService";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
// import { formatPrice } from "../../../../utilities/formatPrice";
import { removelocalStorageToken } from "../../../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../../../utilities/sessionStorage/username";
import { Rating } from "primereact/rating";
import useRatingProduct from "../../../../hooks/useRatingProduct";
import useStoreName from "../../../../hooks/useStoreName";
import { locale } from "../../../../utilities/locale/locale";
import useCategories from "../../../../hooks/useCategories";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import { heic } from "@cloudinary/url-gen/qualifiers/format";
import { InputNumber } from "primereact/inputnumber";
import { CartContext } from "../../../../contexts/CartContext/CartContext";
import { useLocation } from "react-router-dom";

export const CartItem = ({
  product,
  setLoading,
  setOrder,
  setOrderItems,
  setOrderIsEmpty,
  order = {},
}) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const productObj = isFringeBenefitsPage ? product : product.product;

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const toast = useRef(null);
  const { showErrorToast } = useToastContext();
  // const { ratingProduct } = useRatingProduct({
  //   productId: product.product.id,
  //   onError: (code) => showErrorToast({ code }),
  // });
  const { storeName } = useStoreName({
    username: productObj.user.username,
    onError: (code) => showErrorToast(toast.current),
  });
  const orderService = new OrderService();
  const history = useHistory();
  const [isEditingQuantity, setIsEditingQuantity] = useState(false);
  const [quantity, setQuantity] = useState(product.quantity);

  const { categories, loadingCategories } = useCategories({
    onCategoriesError: (code) => showErrorToast({ code }),
  });

  const { removeItemFromCart, removeFringeBenefitItemFromCart } = useContext(CartContext);

  async function changeQuantity(product, quantity) {
    try {
      const stock = product.productVariation
        ? product.productVariation.amountInStock
        : product.product.amountInStock;

      if (quantity <= stock && product.quantity !== quantity) {
        setLoading(true);

        const res = await orderService.postEditItem(
          localStorage.getItem("__extraconomy_token"),
          localStorage.getItem("__extraconomy_username"),
          product.id,
          product.percentualExtraCoin,
          quantity
        );
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });
          setLoading(false);
        } else {
          const orderRes = res.result;
          localStorage.setItem("__extraconomy_order", JSON.stringify(orderRes));
          setOrder(orderRes);
          setOrderItems(orderRes.itens);
          setLoading(false);
        }
      }
    } catch (e) {
      setLoading(false);
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        history.push("/login");
      }
      console.log(e);
    }
  }

  async function deleteProduct(product) {
    try {
      setLoading(true);
      console.log(product);
      if (isFringeBenefitsPage) {
        setOrderItems([]);
        setLoading(false);
        localStorage.removeItem(orderKey);
        setOrderIsEmpty(true);
        removeFringeBenefitItemFromCart([order]);
        return;
      }

      const res = await orderService.postDeleteItem(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        product.id
      );

      if (res.result?.itens.length === 0) {
        setOrderItems([]);
        setLoading(false);
        localStorage.removeItem("__extraconomy_order");
        setOrderIsEmpty(true);
        removeItemFromCart(product);
      } else {
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });
          removeItemFromCart(product);
          setLoading(false);
        } else {
          removeItemFromCart(product);
          const orderRes = res.result;
          localStorage.setItem("__extraconomy_order", JSON.stringify(orderRes));
          setOrder(orderRes);
          setOrderItems(orderRes?.itens ? orderRes.itens : []);
          setLoading(false);
          setOrderIsEmpty(false);
        }
      }
    } catch (e) {
      setLoading(false);
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        history.push("/login");
      }
      console.log(e);
    }
  }

  const getProductDescription = (currentDescription) => {
    if (!currentDescription.includes("<p>")) return currentDescription;
    const regex = /<p>(.*?)<\/p>/;
    const description = currentDescription.match(regex);
    return description[1];
  };

  const subCategories = {
    pt: productObj.subCategory.descriptionPortuguese,
    en: productObj.subCategory.descriptionEnglish,
    it: productObj.subCategory.descriptionItalian,
    es: productObj.subCategory.descriptionSpanish,
  };

  const getCategoryIDBySubcategory = () => {
    if (!categories) return null;
    const category = categories.find((category) =>
      category.subCategories.find(
        (subCategory) => subCategory.descriptionPortuguese === subCategories.pt
      )
    );
    return category?.id;
  };

  const getQueryParams = () => {
    const categoryID = getCategoryIDBySubcategory();
    if (!categoryID) return null;
    return `/shop?category=${categoryID}&subcategory=${product.product.subCategory.id}`;
  };

  if (!productObj.id) {
    return <Loading />;
  }

  const price = isFringeBenefitsPage
    ? productObj.price
    : product.priceUnitary * (product.product.downloadable ? 1 : product.quantity);

  const priceWithFEE = isFringeBenefitsPage ? price : price + price * PLATFORM_PRODUCT_FEE;

  const productBaseURL = isFringeBenefitsPage ? "/fringe-benefit" : "/product";

  return (
    <div className="grid grid-nogutter align-items-center">
      <div className="flex gap-4 h-full col-12 md:col">
        <Link to={`${productBaseURL}?id=${productObj.id}`} style={{ height: "110px" }}>
          <AdvancedImage
            cldImg={
              product.productVariation && product.productVariation.imageid
                ? cloudinaryInstance
                    .image(product.productVariation.imageid)
                    .resize(fill().width(600).height(600))
                    .format("webp")
                : cloudinaryInstance
                    .image(productObj.imageid1)
                    .resize(fill().width(600).height(600))
                    .format("webp")
            }
            height={110}
            className="h-100"
          />
        </Link>
        <div className="flex flex-column gap-2 flex-grow-1">
          <div>
            <Link to={`${productBaseURL}?id=${productObj.id}`}>
              <div className="font-medium" style={{ color: "#344563" }}>
                {productObj.title}
              </div>
            </Link>
          </div>
          <div className="text-xs font-light" style={{ color: "#7A869A" }}>
            {localeText("soldBy")}{" "}
            <Link
              to={`/store?user=${productObj.user.username}`}
              className="font-medium"
              style={{ color: "#7A869A" }}
            >
              {storeName}
            </Link>
          </div>
          <div className="flex align-items-end h-full pb-2" style={{ color: "#344563" }}>
            {" "}
            <div>
              {(!!product.cashback || productObj.cashBackPercentual) && (
                <div className="text-green-500 text-xs">
                  Cashback:{" "}
                  <b>
                    {productObj.currency}{" "}
                    {formatPrice(
                      product.cashback
                        ? product.cashback
                        : (productObj.cashBackPercentual / 100) * productObj.price
                    )}
                  </b>
                </div>
              )}
              <b>
                {productObj.currency} {formatPrice(priceWithFEE)}
              </b>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 md:col-fixed mt-2 sm:mt-0" style={{ maxWidth: "117px" }}>
        <div className="flex flex-column gap-2 justify-content-center text-center">
          {isFringeBenefitsPage ? (
            <InputNumber
              inputId="horizontal-buttons"
              value={order.quantity}
              disabled={true}
              style={{ border: "1px solid #ccc", maxWidth: "117px" }}
              className="border-round-md"
              inputStyle={{ maxWidth: "40px", height: "40px", textAlign: "center" }}
              inputClassName="border-none"
              showButtons
              buttonLayout="horizontal"
              step={1}
              decrementButtonClassName="bg-transparent border-none text-gray-400 hover:text-gray-500"
              incrementButtonClassName="bg-transparent border-none text-gray-400 hover:text-gray-500"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              mode="decimal"
              min={1}
            />
          ) : (
            <>
              {!product.product.downloadable && (
                <>
                  <InputNumber
                    inputId="horizontal-buttons"
                    value={product.quantity}
                    onValueChange={async (e) => {
                      const stock = product.productVariation
                        ? product.productVariation.amountInStock
                        : product.product.amountInStock;
                      if (e.target.value > stock) {
                        return;
                      }

                      await changeQuantity(product, e.target.value);
                    }}
                    style={{ border: "1px solid #ccc", maxWidth: "117px" }}
                    className="border-round-md"
                    inputStyle={{ maxWidth: "40px", height: "40px", textAlign: "center" }}
                    inputClassName="border-none"
                    showButtons
                    buttonLayout="horizontal"
                    step={1}
                    decrementButtonClassName="bg-transparent border-none text-gray-400 hover:text-gray-500"
                    incrementButtonClassName="bg-transparent border-none text-gray-400 hover:text-gray-500"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    mode="decimal"
                    min={1}
                  />
                </>
              )}
            </>
          )}
          <div
            className="cursor-pointer flex justify-content-center align-items-center"
            onClick={async () => await deleteProduct(isFringeBenefitsPage ? productObj : product)}
          >
            <div className="p-2">
              <svg
                /* width="8" */
                height="16"
                viewBox="0 0 8 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.875 3.83301V8.55523C6.875 9.07683 6.45216 9.49967 5.93056 9.49967H2.15278C1.63118 9.49967 1.20833 9.07683 1.20833 8.55523V3.83301"
                  stroke="#7A869A"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3.09726 4.30566V7.61122"
                  stroke="#7A869A"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.98612 4.30566V7.61122"
                  stroke="#7A869A"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.58337 2.41678H0.500042"
                  stroke="#7A869A"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.93054 2.41667L5.67365 1.646C5.54514 1.26016 5.18406 0.999904 4.77738 1H3.30593C2.8989 0.999497 2.53733 1.25983 2.40871 1.646L2.15277 2.41667"
                  stroke="#7A869A"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div style={{ color: "#7A869A", fontSize: "12px" }} className="uppercase pr-2">
              {localeText("delete")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
